import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=20eb6d34&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Carousel.vue?vue&type=style&index=1&id=20eb6d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb6d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\occasion-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20eb6d34')) {
      api.createRecord('20eb6d34', component.options)
    } else {
      api.reload('20eb6d34', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=20eb6d34&scoped=true&", function () {
      api.rerender('20eb6d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "OccasionShop/components/Snippets/Carousel.vue"
export default component.exports